/// <reference types="vite-plugin-svgr/client" />
import { useState } from 'react'
import { Box, Flex, UnstyledButton } from '@mantine/core'
import type { DatesRangeValue } from '@mantine/dates'
import { DatePicker as MantineDatePicker } from '@mantine/dates'
import { useClickOutside } from '@mantine/hooks'
import dayjs from 'dayjs'

import type { DateRangePickerProps } from '@/components/DateRangePicker/DateRangePicker.types'
import { Text } from '@/components/Text/Text'

import ChevronIcon from '@/assets/icons/chevronDown.svg?react'

import classes from './DateRangePicker.module.css'

export function DateRangePicker({
  dates,
  onChange,
  ...props
}: DateRangePickerProps) {
  const [isOpened, setIsOpened] = useState<boolean>(false)
  const [selectedRange, setSelectedRange] = useState<DatesRangeValue>(dates)
  const [button, setButton] = useState<HTMLElement | null>(null)
  const [datePicker, setDatePicker] = useState<HTMLElement | null>(null)

  const handleMonthPickerToggle = () => setIsOpened((prev: boolean) => !prev)

  useClickOutside(
    () => {
      setIsOpened(false)
      setSelectedRange(dates)
    },
    null,
    [button, datePicker],
  )

  return (
    <Box pos="relative">
      <UnstyledButton ref={setButton} onClick={handleMonthPickerToggle}>
        <Flex align="center" gap={12}>
          <Text variant="body_1">
            {dayjs(dates[0]).format('MMM D, YYYY')} -{' '}
            {dayjs(dates[1]).format('MMM D, YYYY')}
          </Text>
          <ChevronIcon
            style={{
              transform: isOpened ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </Flex>
      </UnstyledButton>

      {isOpened && (
        <MantineDatePicker
          ref={setDatePicker}
          allowSingleDateInRange
          className={classes.datePicker}
          classNames={{ day: classes.customDay }}
          defaultDate={dates[1] ?? dayjs().toDate()}
          maxDate={dayjs().toDate()}
          onChange={value => {
            setSelectedRange(value)

            if (!value.includes(null)) {
              onChange(value)
              setIsOpened(false)
            }
          }}
          type="range"
          value={selectedRange}
          {...props}
        />
      )}
    </Box>
  )
}
